<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <span>
                <v-btn plain icon @click="resetTitle" v-bind="attrs" v-on="on" router :to="`${dashboard}`" style="text-decoration:none">
                    <v-icon large>mdi-home-circle-outline</v-icon>
                </v-btn>
            </span>
        </template>
        <span>Dashboard</span>
    </v-tooltip>
</template>

<script>
    import mxauthorization from '@/mixins/authorization';

    export default {
        data() {
            return {
                dashboard: "/dashboard",
                dashboardHans: false,
            }
        },
        mixins: [mxauthorization],
        mounted() {
            this.getAuthorization("dashboard-hans", "dashboardHans");
        },
        watch: {
            dashboardHans(value) {
                if (value) {
                    this.dashboard = "/dashboardHans";
                } else {
                    this.dashboard = "/dashboard";
                }
            }
        },
        methods: {
            resetTitle() {
                document.title = "ARES";
            },
            getAuth(){
                return localStorage.getItem('login')==='dennis'
            },
        }
    }
</script>